var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import * as React from 'react';
import { DateTime } from 'luxon';
import { Col } from '@amzn/atoz-web/Col';
import { DetailedRadio } from '@amzn/atoz-web/DetailedRadio';
import { timeDifferenceWithDurationString } from '@amzn/atoz-shiftapp-utilities';
import { MessageBanner, MessageBannerType } from '@amzn/atoz-web/MessageBanner';
import { Text } from '@amzn/atoz-web/Text';
import { useTranslation } from 'react-i18next';
import { View } from '@amzn/atoz-web/View';
import { styledWithTheme } from '@amzn/atoz-web/Theme';
export var InstantSwapList = function (_a) {
    var instantSwaps = _a.instantSwaps, instantSwapSelected = _a.instantSwapSelected, activeInstantSwap = _a.activeInstantSwap, siteId = _a.siteId, selectionValidationError = _a.selectionValidationError, setSelectionValidationError = _a.setSelectionValidationError, allScheduleDaysForDay = _a.allScheduleDaysForDay;
    var t = useTranslation().t;
    function handleClick(instantSwap) {
        instantSwapSelected(instantSwap);
        setSelectionValidationError(false);
    }
    var hasMultipleShifts = allScheduleDaysForDay.length > 1;
    var multipleShiftsString = allScheduleDaysForDay
        .map(function (_a) {
        var timeRange = _a.timeRange;
        return timeDifferenceWithDurationString(DateTime.fromISO(timeRange.start), DateTime.fromISO(timeRange.end));
    })
        .join('\n');
    return (React.createElement(Col, { gridGap: "S300", padding: ['S500', 0], dataTestId: "InstantSwapList" },
        selectionValidationError === true && (React.createElement(MessageBanner, { type: MessageBannerType.Error, key: 'SelectionValidationError_InstantSwap_Banner', dataTestId: 'SelectionValidationError_InstantSwap_Banner' },
            React.createElement(Text, null, t('shift_management_features_SelectionValidationError_InstantSwap_Banner')))),
        instantSwaps.map(function (instantSwap) {
            var parsedStartTime = DateTime.fromISO(instantSwap.timeRange.start);
            var parsedEndTime = DateTime.fromISO(instantSwap.timeRange.end);
            return (React.createElement(TextWrapper, { key: "instant-swap-wrapper-".concat(instantSwap.id) },
                React.createElement(DetailedRadio, { titleText: hasMultipleShifts
                        ? multipleShiftsString
                        : timeDifferenceWithDurationString(parsedStartTime, parsedEndTime), details: siteId, onChange: function () { return handleClick(instantSwap); }, checked: (activeInstantSwap === null || activeInstantSwap === void 0 ? void 0 : activeInstantSwap.id) === instantSwap.id, key: "instant-swap-".concat(instantSwap.id), "data-testid": "instantSwapRadioButton", error: selectionValidationError })));
        })));
};
// Wraps the title string for multiple shift swap onto two lines
var TextWrapper = styledWithTheme(View)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    white-space: pre;\n"], ["\n    white-space: pre;\n"])));
var templateObject_1;
